module.exports = {"validation":{"required":"Este campo é obrigatório","email":"Endereço de e-mail inválido"}}